import { Modules } from 'mini-usercustomproperties';
import { getModuleUserActivity } from 'mini-usercustomproperties/lib/api/getModuleUserActivity';
import { addDays, getTimestamp, now, startOfDay } from 'owa-datetime';

const WEEKLY_ENGAGEMENT_DAYS_COUNT: number = 7;

/**
 * Determines whether a user is a weekly engaged user for a particular module.
 * Yes, if the user is active 3 or more times in the last 7 days
 * @param module Module to determine engagement of the user
 */
export const isModuleEngagedUser = async (module: Modules): Promise<number> => {
    const userActivity = await getModuleUserActivity(module);
    let countActivity: number = 0;
    for (let dayAgo = 0; dayAgo < WEEKLY_ENGAGEMENT_DAYS_COUNT; dayAgo++) {
        const day: number = getTimestamp(addDays(startOfDay(now()), -dayAgo));
        if (userActivity?.some(dayActivity => dayActivity.day === day)) {
            countActivity++;
        }
        if (countActivity >= 3) {
            return 1;
        }
    }
    return 0;
};
